import { render, staticRenderFns } from "./ProfileSelector.vue?vue&type=template&id=c6353eac&"
import script from "./ProfileSelector.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProfileSelector.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports